import Sniffr from 'sniffr'

export default {
  install: function (app, ) {
    const s = new Sniffr()
    s.sniff(navigator.userAgent)
    app.config.globalProperties.$sniffr = s
  }
}
